// Note: It needs to be in sync with the tailwind.config.js

const colorKeys = [
  "black",
  "white",
  "textPrimary",
  "textSecondary",
  "textMuted",
  "textSubtle",
  "borderDark",
  "borderLight",
  "backgroundLight",
  "backgroundDark",
  "backgroundOffwhite",
  "brandLime",
  "brandTangerine",
  "brandSkyblue",
  "brandApplegreen",
  "colorGreen",
  "colorGreenLight",
  "colorGreenDark",
  "colorRed",
  "colorRedLight",
  "colorRedDark",
  "colorYellow",
  "colorYellowLight",
  "colorYellowDark",
  "colorOrange",
  "colorOrangeLight",
  "colorBlue",
  "colorBlueLight",
] as const;

const bgColors = {
  black: "bg-black",
  white: "bg-white",
  textPrimary: "bg-textPrimary",
  textSecondary: "bg-textSecondary",
  textMuted: "bg-textMuted",
  textSubtle: "bg-textSubtle",
  borderDark: "bg-borderDark",
  borderLight: "bg-borderLight",
  backgroundLight: "bg-backgroundLight",
  backgroundDark: "bg-backgroundDark",
  backgroundOffwhite: "bg-backgroundOffwhite",
  brandLime: "bg-brandLime",
  brandTangerine: "bg-brandTangerine",
  brandSkyblue: "bg-brandSkyblue",
  brandApplegreen: "bg-brandApplegreen",
  colorGreen: "bg-colorGreen",
  colorGreenLight: "bg-colorGreenLight",
  colorGreenDark: "bg-colorGreenDark",
  colorRed: "bg-colorRed",
  colorRedLight: "bg-colorRedLight",
  colorRedDark: "bg-colorRedDark",
  colorYellow: "bg-colorYellow",
  colorYellowLight: "bg-colorYellowLight",
  colorYellowDark: "bg-colorYellowDark",
  colorOrange: "bg-colorOrange",
  colorOrangeLight: "bg-colorOrangeLight",
  colorBlue: "bg-colorBlue",
  colorBlueLight: "bg-colorBlueLight",
} as const satisfies Record<(typeof colorKeys)[number], string>;

const textColors = {
  black: "text-black",
  white: "text-white",
  textPrimary: "text-textPrimary",
  textSecondary: "text-textSecondary",
  textMuted: "text-textMuted",
  textSubtle: "text-textSubtle",
  borderDark: "text-borderDark",
  borderLight: "text-borderLight",
  backgroundLight: "text-backgroundLight",
  backgroundDark: "text-backgroundDark",
  backgroundOffwhite: "text-backgroundOffwhite",
  brandLime: "text-brandLime",
  brandTangerine: "text-brandTangerine",
  brandSkyblue: "text-brandSkyblue",
  brandApplegreen: "text-brandApplegreen",
  colorGreen: "text-colorGreen",
  colorGreenLight: "text-colorGreenLight",
  colorGreenDark: "text-colorGreenDark",
  colorRed: "text-colorRed",
  colorRedLight: "text-colorRedLight",
  colorRedDark: "text-colorRedDark",
  colorYellow: "text-colorYellow",
  colorYellowLight: "text-colorYellowLight",
  colorYellowDark: "text-colorYellowDark",
  colorOrange: "text-colorOrange",
  colorOrangeLight: "text-colorOrangeLight",
  colorBlue: "text-colorBlue",
  colorBlueLight: "text-colorBlueLight",
} as const satisfies Record<(typeof colorKeys)[number], string>;

export const Colors = {
  bg: bgColors,
  text: textColors,
} as const;
